/**
 * Example query function.
 *
 * @param client the internal client instance
 * @param config the internal client configuration object
 * @param input input parameters for paring down the search results
 *
 * @category Query Functions - getExample
 * @category Query Functions
 */
export const getExample = (client, config, input) => {
    const { customerCode } = config;
    return client.get(`/${customerCode}/slots`, {
        params: input
    });
};
//# sourceMappingURL=getExample.js.map